module.exports = __webpack_public_path__ + "img/waistline pocket position.0536a2e3.png";